// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gDdHm","left":"styles_left__2xZ_H"};